var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FloatingBallGroup',{attrs:{"tool-type":_vm.resolvedToolType,"collect-config":_vm.collectConfig,"feedback-config":_vm.feedbackConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }